import FormInputTypes from '../components/atoms/formEnums/formInputTypes';
import tableExternalResources from './tableExternalResources';
import tableVodCatalog from './tableVodTemplateCatalog'

export default {
  title: 'General Settings',
  attributeName: 'sourceFilesFormGroup',
  fields: [
    {
      attributeName: 'template',
      type: FormInputTypes.OTHER_RESOURCE,
      label: 'Template',
      helpText: 'Fill the form with a template.',
      errorText: '',
      fromCatalog: tableVodCatalog,
    },
    {
      attributeName: 'name',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      placeholder: 'Video name',
      label: 'Name',
      // required: true,
      helpText: 'Name to identify the job in the XMS.',
      errorText: '',
    },
    {
      attributeName: 'folder',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      placeholder: 'Folder name',
      label: 'Folder',
      // required: true,
      helpText: 'Folder to be moved into the origins.',
      errorText: '',
    },

     {
      attributeName: 'isTemplate',
      type: FormInputTypes.CHECKBOX,
      label: 'Save as template',
      helpText: 'Check this button if you want to save this job as a template.',
      errorText: '',
      disabledWhenEdit:true
    },
    {
      attributeName: 'saveComposeExperience',
      type: FormInputTypes.CHECKBOX,
      label: 'Save media',
      helpText: 'Check this button if you want to save this job in a new media.',
      errorText: '',
      disabledWhenEdit:true

    },
  ],
};
